module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [(_vm.withAvatar) ? _c('v-list-tile-avatar', {
    staticClass: "ma-0 mr-2 pa-0 white--text",
    staticStyle: {
      "min-width": "30px"
    },
    attrs: {
      "size": 30,
      "color": "teal"
    }
  }, [(_vm.profilePicture) ? _c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.initials(_vm.item))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item && _vm.item.id) ? _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.profilePicture && !_vm.withAvatar) ? _c('v-avatar', {
    attrs: {
      "size": 24
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  })], 1) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.fullname) + "\n      "), _vm._t("title-chips")], 2), _vm._v(" "), (!_vm.withAvatar) ? _c('v-list-tile-sub-title', {
    staticClass: "ml-4 pl-1"
  }, [_vm._v("\n      " + _vm._s(_vm.profession) + "\n    ")]) : _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.profession)
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0167f597","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/PractitionerListItem.vue
// module id = 1309
// module chunks = 9